export default __webpack_public_path__ + "static/banner-c4129744067aac4f28ee6720013155f3.svg";